/* ═══════════════════════════════════════════════════════════════
   SIRCABLE WISHLIST
   localStorage-based wishlist. No login required.
   Buttons: [data-wl-trigger] with data-product-id="..."
   Header badge: #sircable-wl-count
   Header icon:  #sircable-wl-header-btn
═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var KEY = 'sircable_wishlist';

  /* ── Storage ── */
  var WL = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    },
    save: function (ids) {
      try { localStorage.setItem(KEY, JSON.stringify(ids)); } catch (e) {}
    },
    has: function (id) {
      return this.get().indexOf(String(id)) !== -1;
    },
    toggle: function (id) {
      var list = this.get();
      var sid  = String(id);
      var idx  = list.indexOf(sid);
      if (idx === -1) { list.push(sid); }
      else            { list.splice(idx, 1); }
      this.save(list);
      return idx === -1; /* true = added, false = removed */
    },
    count: function () {
      return this.get().length;
    }
  };

  /* ── Header badge ── */
  function updateBadge() {
    var badge = document.getElementById('sircable-wl-count');
    if (!badge) return;
    var n = WL.count();
    badge.textContent = n;
    badge.style.display = n > 0 ? '' : 'none';
  }

  /* ── Sync all buttons on the page to current wishlist state ── */
  function syncButtons() {
    document.querySelectorAll('[data-wl-trigger]').forEach(function (btn) {
      var id    = btn.getAttribute('data-product-id');
      var saved = id && WL.has(id);
      btn.classList.toggle('is-saved', !!saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  }

  /* ── Bind click handlers ── */
  function initButtons() {
    document.querySelectorAll('[data-wl-trigger]').forEach(function (btn) {
      if (btn._wlBound) return; /* avoid double-bind */
      btn._wlBound = true;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var id    = btn.getAttribute('data-product-id');
        if (!id) return;

        var added = WL.toggle(id);
        btn.classList.toggle('is-saved', added);
        btn.setAttribute('aria-pressed', added ? 'true' : 'false');

        /* Pop animation — remove then re-add to restart */
        btn.classList.remove('sircable-wl-pop');
        void btn.offsetWidth;
        btn.classList.add('sircable-wl-pop');
        btn.addEventListener('animationend', function () {
          btn.classList.remove('sircable-wl-pop');
        }, { once: true });

        updateBadge();
      });
    });
  }

  /* ── Init ── */
  function init() {
    syncButtons();
    initButtons();
    updateBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Expose API for dynamically rendered cards (e.g. the "You May Also Like" slider) */
  window.WL = {
    initButtons: initButtons,
    syncButtons: syncButtons,
    updateBadge: updateBadge
  };
})();

